import React from 'react'
import { useLocation, useNavigate, matchPath } from 'react-router-dom'

import routes from '../routes'

import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react-pro'

const AppBreadcrumb = () => {
  const currentLocation = useLocation().pathname
  const navigate = useNavigate();

  const getRouteName = (pathname, routes) => {
    for (const route of routes) {
      if (route.path === '*') continue;
      if (matchPath({ path: route.path, end: true }, pathname)) {
        return route.name;
      }
    }
    return false;
  }

  const getBreadcrumbs = (location) => {
    const breadcrumbs = []
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`
      const routeName = getRouteName(currentPathname, routes)
      routeName &&
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length ? true : false,
        })
      return currentPathname
    })
    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)

  return (
    <CBreadcrumb className="">
      <CBreadcrumbItem
        onClick={() => navigate("/dashboard")}
        style={{cursor: 'pointer', fontSize: '1.25rem', marginTop: '0.5rem', marginBottom: '0.5rem' }}
      >
        Home
      </CBreadcrumbItem>
      {breadcrumbs.map((breadcrumb, index) => (
        <CBreadcrumbItem
          key={index}
          active={breadcrumb.active || undefined}
          onClick={!breadcrumb.active ? () => navigate(breadcrumb.pathname) : undefined}
          style={{
            fontSize: '1.25rem',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
            cursor: !breadcrumb.active ? 'pointer' : 'default',
          }}
        >
          {breadcrumb.name}
        </CBreadcrumbItem>
      )
      )}
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
